import { MutationTree } from 'vuex';
import { ComplaintState } from './types';
import { idGenerator } from '@/services';

export const mutations: MutationTree<ComplaintState> = {
  RESET(state) {
    state.requestId = idGenerator.getUid();
  },
};
